import { Container, Point, Sprite } from 'pixi.js'
import LayerBase from './LayerBase'
import Item from '../Item'
import type { ILayer, IItemInfo, IItem } from '../../data/types'
import { dimensions } from '../../config/settings'

export default class Layer extends LayerBase {
  public readonly items: Item[] = []
  private readonly extraContainer: Container

  constructor(layerSize: Point, layerData: ILayer) {
    super(layerData.name, layerSize, dimensions)
    this.sortableChildren = true

    this.createBackground(layerData.background)
    this.createItems(layerData.items)
    // this.createForeground(layerData.foreground)
    this.extraContainer = new Container()
    this.extraContainer.eventMode = 'passive'
    this.extraContainer.zIndex = 100 // Ensure it's above all items
    this.addChild(this.extraContainer)
  }

  // Adds background sprites (lowest layer visuals).
  private createBackground(backgroundData?: IItemInfo[]): void {
    backgroundData?.forEach((bg) => {
      const sprite = Sprite.from(bg.id)
      sprite.position.set(bg.x, bg.y)
      sprite.zIndex = 0
      sprite.eventMode = 'passive'
      this.addChild(sprite)
    })
  }

  // Adds foreground sprites
  private createForeground(foreground?: IItemInfo[]): void {
    foreground?.forEach((fg) => {
      const sprite = Sprite.from(fg.id)
      sprite.position.set(fg.x, fg.y)
      sprite.zIndex = 5
      sprite.eventMode = 'passive'
      this.addChild(sprite)
    })
  }

  // Adds interactive items to the layer.
  private createItems(itemsData?: IItem[]): void {
    itemsData?.forEach((itemData, idx) => {
      // Fallbacks because the trimmed dataset removed hint/beak/activity metadata.
      // const hint = itemData.hint ?? {
      //   x: itemData.hit.x + itemData.hit.w / 2,
      //   y: itemData.hit.y + itemData.hit.h / 2,
      // }
      // const beak = itemData.beak ?? hint
      const hydratedItemData = { ...itemData }

      // Minimal “activity” placeholder so bullets/titles have data.
      const activity = {
        title: itemData.id,
        day: idx + 1, // keeps bullets distinct; 0 would render as a dot
        positionId: itemData.id,
      }

      const item = new Item(hydratedItemData, activity)
      item.show(true, true)
      this.items.push(item)
      this.addChild(item)
    })
  }

  // Provides a container for special effects (e.g., snow, smoke).
  public addExtra(displayObject: Container, isInteractive: boolean = false): void {
    if (!isInteractive) {
      displayObject.eventMode = 'passive'
      displayObject.interactiveChildren = false
    }
    this.extraContainer.addChild(displayObject)
  }
}
